import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const Container = styled.div `
  display: grid;

  grid-template-areas: 'side' 'main';
  grid-template-rows: min-content auto;

  ${({ withHeader, asideCollapsePosition }) => withHeader &&
    `grid-template-areas: ${asideCollapsePosition === 'top' ? "'header' 'side' 'main'" : "'header' 'main' 'side'"};
  `}

  @media (min-width: 960px) {
    grid-template-areas: 'main side';
    grid-template-columns: auto min-content;
    ${({ withHeader }) => withHeader && `grid-template-areas: 'header header' 'main side';`}
  }

  width: 100%;
  grid-gap: 20px;
  overflow: hidden;
  margin: 0 auto;
`;
const HeaderContainer = styled.div `
  grid-area: header;
  width: 100%;
  height: 100%;
`;
const Main = styled.div `
  grid-area: main;
  width: 100%;
  height: 100%;
  overflow: auto;
`;
const Side = styled.div `
  grid-area: side;
  width: 100%;
  height: 100%;
  overflow: auto;

  @media (min-width: 960px) {
    width: 250px;
  }

  & > :not(:first-child) {
    margin-top: 20px;
  }
`;
const PageLayout = ({ header, aside, asideCollapsePosition = 'top', children }) => (React.createElement(Container, { withHeader: !!header, asideCollapsePosition: asideCollapsePosition },
    header && React.createElement(HeaderContainer, null, header),
    React.createElement(Main, null, children),
    React.createElement(Side, null, aside)));
PageLayout.propTypes = {
    children: PropTypes.node,
    aside: PropTypes.node,
    header: PropTypes.node,
};
PageLayout.defaultProps = {
    header: null,
};
export default PageLayout;
//# sourceMappingURL=index.js.map